module.exports = __webpack_public_path__ + "static/img/vector.15db21bf.svg";